/* HRD fitment pure logic. UMD: browser global HRDFitmentCore + CommonJS for node tests. */
(function (root, factory) {
  if (typeof module !== 'undefined' && module.exports) module.exports = factory();
  else root.HRDFitmentCore = factory();
})(typeof self !== 'undefined' ? self : this, function () {
  var CAP = new Date().getFullYear() + 1;

  function endOf(v) { return v.year_end == null ? CAP : v.year_end; }
  function inRange(v, year) { return year >= v.year_start && year <= endOf(v); }

  function years(index) {
    var set = {};
    index.vehicles.forEach(function (v) {
      for (var y = v.year_start; y <= endOf(v); y++) set[y] = true;
    });
    return Object.keys(set).map(Number).sort(function (a, b) { return b - a; });
  }

  function makesForYear(index, year) {
    var set = {};
    index.vehicles.forEach(function (v) { if (inRange(v, year)) set[v.make] = true; });
    return Object.keys(set).sort();
  }

  function modelsForYearMake(index, year, make) {
    var out = [], seen = {};
    index.vehicles.forEach(function (v, i) {
      if (v.make === make && inRange(v, year) && !seen[v.model]) {
        seen[v.model] = true;
        out.push({ vehicleIdx: i, model: v.model, chassis: v.chassis || null });
      }
    });
    return out.sort(function (a, b) { return a.model.localeCompare(b.model); });
  }

  function vehicleLabel(index, vehicleIdx, year) {
    var v = index.vehicles[vehicleIdx];
    return year + ' ' + v.make + ' ' + v.model;
  }

  function resolveYmm(index, ymm) {
    if (!ymm || typeof ymm !== 'string') return null;
    var parts = ymm.split('|');
    if (parts.length !== 3) return null;
    var year = Number(parts[0]);
    if (!year) return null;
    var models = modelsForYearMake(index, year, parts[1]);
    for (var i = 0; i < models.length; i++) {
      if (models[i].model === parts[2]) {
        return { vehicleIdx: models[i].vehicleIdx, year: year, label: vehicleLabel(index, models[i].vehicleIdx, year) };
      }
    }
    return null;
  }

  /* The same car (year+make+model) can appear as multiple vehicle rows with
     different year spans (different products' fitment claims). A fitment list
     covers a car if any of its rows shares the car's make+model and, when a
     year is given, spans that year. */
  function coversCar(index, fitments, v, year) {
    for (var i = 0; i < fitments.length; i++) {
      var f = index.vehicles[fitments[i]];
      if (f && f.make === v.make && f.model === v.model && (year == null || inRange(f, year))) return true;
    }
    return false;
  }

  /* Callers must pass year (the garage always has it); when year is omitted,
     identity matches skip the range check. */
  function fitStatus(index, handle, vehicleIdx, year) {
    var p = index.products[handle];
    if (!p) return 'unknown';
    if (p.universal) return 'universal';
    if (vehicleIdx != null) {
      if (p.fitments.indexOf(vehicleIdx) !== -1) return 'fits';
      var v = index.vehicles[vehicleIdx];
      if (v && coversCar(index, p.fitments, v, year)) return 'fits';
    }
    return 'no-fit';
  }

  function productMake(index, handle) {
    var p = index.products[handle];
    if (!p || p.universal || !p.fitments.length) return null;
    return index.vehicles[p.fitments[0]].make;
  }

  /* Callers must pass year; when omitted, identity matches skip the range check. */
  function familyMatch(index, handle, vehicleIdx, year) {
    var p = index.products[handle];
    if (!p) return null;
    var v = vehicleIdx != null ? index.vehicles[vehicleIdx] : null;
    var handles = Object.keys(index.products).sort();
    for (var i = 0; i < handles.length; i++) {
      var h = handles[i], q = index.products[h];
      if (h === handle || q.family !== p.family) continue;
      if (q.fitments.indexOf(vehicleIdx) !== -1) return h;
      if (v && coversCar(index, q.fitments, v, year)) return h;
    }
    return null;
  }

  return { years: years, makesForYear: makesForYear, modelsForYearMake: modelsForYearMake, vehicleLabel: vehicleLabel, resolveYmm: resolveYmm, fitStatus: fitStatus, productMake: productMake, familyMatch: familyMatch, inRange: inRange };
});
